<template>
	<div :style="{direction: $vs.rtl ? 'rtl' : 'ltr'}">
		<vs-sidebar
			v-if="isSidebarEditActive"
			parent="body"
			click-not-close
			position-right
			default-index="1"
			color="primary"
			class="add-new-data-sidebar items-no-padding"
			v-model="isSidebarEditActive"
		>
			<div class="flex items-center justify-between px-6 p-4" style="background: #eee">
				<h4>{{ $t("Crud.Update") + " " + $t("Optimization.Optimization") + " " + dataOptimizationEdit.id }}</h4>
				<feather-icon
					icon="XIcon"
					@click.stop="isSidebarEditActive = false"
					class="cursor-pointer"
				></feather-icon>
			</div>
			<optimization-edit :data="dataOptimizationEdit" @showSidebarEdit="closeSidebar" @refreshList="refresh">
			</optimization-edit>
		</vs-sidebar>
		<div class="content-action flex items-center justify-center">
			<vs-button
				color="dark"
				type="flat"
				icon-pack="feather"
				icon="icon-repeat"
				:title="$t('Routing.Buttons.ReOptimizeRoutes')"
				@click.stop="reOptimization"
			></vs-button>
			<vs-button
				color="dark"
				type="flat"
				icon-pack="feather"
				icon="icon-map"
				:disabled="params.data.status === 'ERROR' || params.data.status === 'PROCESSING'"
				:title="$t('Routing.Buttons.SeeRoute')"
				@click.stop="seeRoute(params.data)"
			></vs-button>
			<vs-dropdown vs-trigger-click class="ml-2 cursor-pointer" :title="$t('ViewMore')">
				<feather-icon
					icon="MoreVerticalIcon"
					svgClasses="h-5 w-5 text-dark hover:text-danger cursor-pointer"
					:title="$t('Crud.Delete')"
				/>
				<vs-dropdown-menu class="w-48">
					<vs-dropdown-item @click.stop="editRecord(params.data)">
						<div class="flex items-center mt-2">
							<i class="material-icons mr-1"> edit </i>
							<span class="font-semibold">{{ $t("Crud.Update") }}</span>
						</div>
					</vs-dropdown-item>
					<vs-dropdown-item
						:disabled="params.data.status === 'ERROR' || params.data.status === 'PROCESSING'"
						@click.stop="showInformation(params.data)"
					>
						<div class="flex items-center mt-2">
							<i class="material-icons mr-1">info</i>
							<span class="font-semibold">{{ $t("Information") }}</span>
						</div>
					</vs-dropdown-item>
					<hr style="border: 0.1px solid #ccc" class="mt-2" />
					<vs-dropdown-item v-if="OptimizationDeletePermission" @click.stop="confirmDeleteRecord">
						<div class="flex items-center hover:text-danger stroke-current">
							<i class="material-icons text-danger m1-2"> delete </i>
							<span class="text-danger font-semibold">{{ $t("Crud.Delete") }}</span>
						</div>
					</vs-dropdown-item>
				</vs-dropdown-menu>
			</vs-dropdown>
		</div>
		<vs-popup
			id="error-with-loading"
			class="vs-con-loading__container"
			:title="null"
			:active.sync="showPopup"
			fullscreen
		>
			<optimization-view :data="dataOptimization" :iconRight="true" />
		</vs-popup>
	</div>
</template>

<script>
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import OptimizationView from "../OptimizationView.vue";
import OptimizationEdit from "../OptimizationEdit.vue";

export default {
	name: "CellRendererActions",
	components: {OptimizationView, OptimizationEdit},
	data() {
		return {
			showPopup: false,
			dataOptimization: {},
			dataOptimizationEdit: {},
			isSidebarEditActive: false,
		};
	},
	computed: {
		OptimizationDeletePermission() {
			return this.$store.getters.checkPermission("OPTIMIZATION_D");
		},
	},
	methods: {
		async seeRoute() {
			this.$store.commit("SET_ROUTING_TYPE", this.params.data.routing_api);
			await this.$store.dispatch("moduleRoutingType/saveRouting", this.params.data.routing_api);
			this.$router.push("/dashboard/optimization-map/" + this.params.data.id).catch(() => {});
		},
		editRecord(data) {
			this.dataOptimizationEdit = data;
			this.isSidebarEditActive = true;
		},
		async reOptimization() {
			await this.$store.dispatch("moduleRoutingType/saveRouting", this.params.data.routing_api);
			this.$store.commit("SET_ROUTING_TYPE", this.params.data.routing_api);
			this.$router.push("/dashboard/reoptimization/" + this.params.data.id).catch(() => {});
		},
		showInformation(data) {
			this.dataOptimization = data;
			this.showPopup = true;
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text:
					this.$t("Optimization.DeleteOptimization.Text1") +
					` "${this.params.data.name}"? ` +
					this.$t("Optimization.DeleteOptimization.Text2"),
				accept: this.deleteRecord,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$store
				.dispatch("moduleOptimization/deleteById", this.params.data.id)
				.then((res) => {
					this.showDeleteSuccess();
				})
				.catch((err) => {
					if (err.response.status === 404) {
						return;
					}
					console.error(err);
				});
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("Optimization.CellRenderer.DeleteSuccess.Title"),
				text: this.$t("Optimization.CellRenderer.DeleteSuccess.Text"),
			});
		},
		closeSidebar(val) {
			this.isSidebarEditActive = val;
		},
		refresh() {
			const payload = {
				sort: "desc",
				order_by: ["id"],
			};
			this.$vs.loading();
			this.$store
				.dispatch("moduleOptimization/optimizationFilter", payload)
				.then((res) => this.$vs.loading.close())
				.catch((err) => {
					this.$vs.loading.close();
					console.error(err);
				});
		},
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
	},
};
</script>
<style lang="scss" scoped>
.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 51010;
		background-color: rgba(0, 0, 0, 0.7);
	}

	::v-deep .vs-sidebar {
		z-index: 51010;
		width: 450px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
</style>
